import { Button, Col, DatePicker, Form, Row } from "antd";
import moment from "moment";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";

const StyledFilterContainer = styled.div`
  &,
  & .filter {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    &__item {
      margin: 0.5rem;

      & .ant-form-item {
        margin: 0;
      }

      &--submit {
        align-self: flex-end;
      }
    }
  }
`;

export const AppEarningPayoutsFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [form] = Form.useForm();

  useEffect(() => {
    const month = searchParams.get("month");
    form.setFieldsValue({ month: month ? moment(month, "YYYY-MM") : moment() });
  }, [form, searchParams]);

  const onSearch = (values: { month?: moment.Moment }) => {
    const params: Record<string, string> = {};
    if (values.month) params.month = values.month.format("YYYY-MM");
    setSearchParams(params);
  };

  const onReset = () => {
    form.resetFields();
    setSearchParams({});
  };

  return (
    <StyledFilterContainer>
      <Form
        form={form}
        name="earning-payouts-filter-form"
        onFinish={onSearch}
        layout="vertical"
        style={{ width: "100%" }}
      >
        <Row className="filter">
          <Col xs={20} sm={8} md={6} lg={5} className="filter__item">
            <Form.Item name="month" label="Month">
              <DatePicker
                picker="month"
                size="small"
                style={{ width: "100%" }}
                format="YYYY-MM"
              />
            </Form.Item>
          </Col>
          <Col xs={20} sm={4} md={2} lg={2} className="filter__item filter__item--submit">
            <Form.Item>
              <Button type="primary" htmlType="submit" size="small">
                Search
              </Button>
            </Form.Item>
          </Col>
          <Col xs={20} sm={4} md={2} lg={2} className="filter__item filter__item--submit">
            <Form.Item>
              <Button size="small" onClick={onReset}>
                Reset
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </StyledFilterContainer>
  );
};
